import { LoadablePaint } from '@confluence/loadable';

export const ContentHistoryLoader = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ContentHistory" */ './ContentHistory'))
			.ContentHistory,
});
